import { PropsWithChildren } from "react";

interface HeaderColumnProps
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {}

export const HeaderColumns = ({ children, ...props }: HeaderColumnProps) => {
  return (
    <div className="relative flex flex-row w-fit h-4" {...props}>
      {children}
    </div>
  );
};
